import React, { createContext, useContext, useState } from 'react';
import { initProjectRoutes as getProjectRoutes, clearTableInfoCache } from '../configs/menuItems';

const ProjectRoutesContext = createContext();

export const useProjectRoutes = () => {
  const context = useContext(ProjectRoutesContext);
  if (!context) {
    throw new Error('useProjectRoutes must be used within a ProjectRoutesProvider');
  }
  return context;
};

export const ProjectRoutesProvider = ({ children }) => {
  const [projectRoutes, setProjectRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadProjectRoutes = async (forceReload = false) => {
    if (forceReload) {
      clearTableInfoCache();
    }

    if (loading || (projectRoutes.length > 0 && !forceReload)) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const routes = await getProjectRoutes();
      setProjectRoutes(routes);
      return routes;
    } catch (err) {
      console.error('Failed to load project routes:', err);
      setError(err);
      setProjectRoutes([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProjectRoutesContext.Provider
      value={{
        projectRoutes,
        loading,
        error,
        loadProjectRoutes
      }}
    >
      {children}
    </ProjectRoutesContext.Provider>
  );
};

export default ProjectRoutesContext; 